import React from "react";
import { Input } from "@/components/ui/input";
import type { FieldRendererProps } from "./types";

export const UrlFieldRenderer: React.FC<FieldRendererProps> = ({ field, value, onChange }) => {
  return (
    <Input
      type="url"
      value={(value as string) ?? (field.defaultValue as string) ?? ""}
      onChange={(e) => onChange(e.target.value || undefined)}
      placeholder={field.placeholder || `https://example.com`}
      className=""
    />
  );
};
